// Native
import { useState } from "react"

// Components
import { Center, Grid, GridItem, Stack} from "@chakra-ui/react"
import { Options, Stat } from "components"
import ClientsDailyGrowthChart from "./clientsDailyGrowthChart"

// Config
import { Moment, Enums } from "config"

// Hooks
import { useReport } from "hooks"

export default function Clients({ ...props }){

    const [ period, setPeriod ] = useState(Enums.Period.LAST_7_DAYS)
    const clients_total = useReport('clients_total', period)
    const clients_daily_growth_average = useReport('clients_daily_growth_average', period)
    const clients_expired = useReport('clients_expired')
    const clients_demographic_cities = useReport('clients_demographic_cities', period)
    const clients_demographic_states = useReport('clients_demographic_states', period)
    const clients_demographic_countries = useReport('clients_demographic_countries', period)

    const periods = Object.keys(Enums.Period).map(item => ({ children: Enums.Period.data(Enums.Period[item]).label, value: Enums.Period[item] }))

    return(
    <>

    <Center mb={12}>
        <Options 
            onChange={setPeriod}
            defaultSelected={period}
            options={periods}
            size="xs"
        />
    </Center>

    {/* Sessão 01 | Linha do tempo novos clientes */}
    <ClientsDailyGrowthChart period={period} />

    <Grid templateColumns="24% 24% 24% 24%" gap={6}>

        <GridItem>
            <Stat.Item 
                label="Contas cadastradas" 
                value={clients_total.data?.data} 
                helper={`${Moment(clients_total.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(clients_daily_growth_average.data?.metadata?.ends).format('DD/MM/YYYY')}`} 
                loading={clients_total.isLoading}
            />
        </GridItem>

        <GridItem>
            <Stat.Item 
                label="Média de crescimento diário" 
                value={`~ ${parseInt(clients_daily_growth_average?.data?.data) ?? ''}/dia`} 
                helper={`${Moment(clients_daily_growth_average.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(clients_daily_growth_average.data?.metadata?.ends).format('DD/MM/YYYY')}`} 
                loading={clients_daily_growth_average.isLoading} 
            />
        </GridItem>

        <GridItem>
            {/* <Stat label="Contas cadastradas (Total)" value={report.data?.adhesion?.total} helper="Total de contas cadastradas" /> */}
        </GridItem>

        <GridItem>
            <Stat.Item 
                label="Contas expiradas (Total)" 
                value={clients_expired?.data?.data} 
                helper="Total de contas expiradas" 
                loading={clients_expired.isLoading} 
            />
        </GridItem>

    </Grid>

    <Grid templateColumns="33% 33% 33%" gap={6} mt={6}>
        
        <GridItem>
            <Stat.Box title="Consultores por cidade:" loading={clients_demographic_cities.isLoading} helper={`${Moment(clients_demographic_cities.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(clients_demographic_cities.data?.metadata?.ends).format('DD/MM/YYYY')}`} >
                <Stack spacing={2}>
                    { clients_demographic_cities?.data?.data?.map((item, index) => <Stat.ListItem label={`${index+1}. ${item.city_name}, ${item.state_name}`} value={item.total} />) }
                </Stack>
            </Stat.Box>
        </GridItem>

        <GridItem>
            <Stat.Box title="Consultores por estado:" loading={clients_demographic_states.isLoading} helper={`${Moment(clients_demographic_states.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(clients_demographic_states.data?.metadata?.ends).format('DD/MM/YYYY')}`}>
                <Stack spacing={2}>
                    { clients_demographic_states?.data?.data?.map((item, index) => <Stat.ListItem label={`${index+1}. ${item.state_name}, ${item.country_name}`} value={item.total} />) }
                </Stack>
            </Stat.Box>
        </GridItem>

        <GridItem>
            <Stat.Box title="Consultores por país:" loading={clients_demographic_countries.isLoading} helper={`${Moment(clients_demographic_countries.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(clients_demographic_countries.data?.metadata?.ends).format('DD/MM/YYYY')}`}>
                <Stack spacing={2}>
                    { clients_demographic_countries?.data?.data?.map((item, index) => <Stat.ListItem label={`${index+1}. ${String.fromCharCode(item.country_emoji)} ${item.country_name}`} value={item.total} />) }
                </Stack>
            </Stat.Box>
        </GridItem>

    </Grid>

    </>
    )
}